import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import CourseCard from "../components/CourseCard";
import AddCourseCard from "../components/AddCourseCard";
import AddCourseDialog from "../components/AddCourseDialog";


const initialCourses = [
{ id: "ABC123", name: "Computer", students: 30 },
{ id: "DEF456", name: "Mathematics", students: 25 },
{ id: "GHI789", name: "Science", students: 21 },
];


export default function Courses() {
const [courses, setCourses] = useState(initialCourses);
const [open, setOpen] = useState(false);


const addCourse = (course) => {
setCourses([...courses, course]);
};


return (
<>
<Grid container spacing={3} columns={12} alignItems="stretch">
{courses.map((course, index) => (
<Grid item xs={12} sm={6} md={4} key={index} sx={{ display: "flex" }}>
<CourseCard course={course} />
</Grid>
))}
<Grid item xs={12} sm={6} md={4} sx={{
      display: "flex"
    }}>
<AddCourseCard onClick={() => setOpen(true)} />
</Grid>
</Grid>


<AddCourseDialog open={open} onClose={() => setOpen(false)} onCreate={addCourse} />
</>
);
}